<template>
    <div class="attr">
        <span class="attr-label">{{ value.label }}</span>
        <rating-stars :value="value.value" :config="value.config" />
    </div>
</template>

<script>
import RatingStars from './RatingStars'

export default {
    name: 'RatingAttribute',
    components: { RatingStars },
    props: ['value']
}
</script>

<style scoped>
.attr-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 4px;
}
</style>
